import { useSelector } from 'react-redux';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_SIZE_TABLET_SMALL,
  SCREEN_WIDTH_QUERIES,
} from '../utils/constant';

const useResponsive = () => {
  const {
    global: { mediaQueryValue },
  } = useSelector((state) => state?.certifications?.list);

  const tabletSmallQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_TABLET_SMALL
  );

  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );

  if (!tabletSmallQuery || !mobileXlargeQuery || !mediaQueryValue) {
    return {
      isTabletWidth: false,
      isMobileXlargeWidth: false,
    };
  }

  const isTabletWidth = tabletSmallQuery.value <= mediaQueryValue;
  const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;

  return {
    isTabletWidth,
    isMobileXlargeWidth,
  };
};

export default useResponsive;
